/**
 * Defined the orientation of stripes in {@link StripeMaterialProperty}.
 *
 * @enum {number}
 */
const StripeOrientation = {
  /**
   * Horizontal orientation.
   * @type {number}
   */
  HORIZONTAL: 0,

  /**
   * Vertical orientation.
   * @type {number}
   */
  VERTICAL: 1,
};
export default Object.freeze(StripeOrientation);
